import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import { CloseButton } from './CloseButton'
import { useTheme } from '@mui/material/styles'

type Props = {
  title: string
  count: number
  table: JSX.Element
  subHeader?: JSX.Element
  dataTestId: string
}

export function Layout(props: Props) {
  const { title, count, table, subHeader, dataTestId } = props

  const header = `${title} (${count})`
  const theme = useTheme()
  return (
    <Stack mx={-2} mb={-2} mt={2} p={2} bgcolor="#fafafa">
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          ml={1}
          // body1 is wrong in the theme, need to fix later
          variant="body1"
          fontSize="16px"
          lineHeight="150%"
          letterSpacing="0.15px"
        >
          {header}
        </Typography>

        <CloseButton />
      </Stack>

      {subHeader}

      <Box
        mt={2}
        bgcolor={theme.palette.common.white}
        data-test-id={dataTestId}
      >
        {table}
      </Box>
    </Stack>
  )
}
